<cng-layout-legacy id="hypervision" [menuRef]="menu" [mainRef]="main"></cng-layout-legacy>

<!-- Menu template -->
<ng-template #menu>
  <ul>
    <li
      class="dropdown"
      [ngClass]="{
        open: openCenter
      }"
    >
      <a
        (click)="toggleCenter()"
        [ngClass]="{
          current: url$ | async | mapper: isState:HypervisionState.DETAILED:HypervisionState.SYNTHETIC
        }"
      >
        {{ 'hypervision:menu.center' | translate }}</a
      >
      <ul [hidden]="!openCenter">
        <li>
          <a
            [routerLink]="[HypervisionState.DETAILED]"
            routerLinkActive
            #detailedRla="routerLinkActive"
            [active]="detailedRla.isActive"
            [disabled]="detailedRla.isActive"
            [ngClass]="{ current: detailedRla.isActive }"
          >
            {{ 'hypervision:hypervision.detailed.title' | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="[HypervisionState.SYNTHETIC]"
            routerLinkActive
            #syntheticRla="routerLinkActive"
            [active]="syntheticRla.isActive"
            [disabled]="syntheticRla.isActive"
            [ngClass]="{ current: syntheticRla.isActive }"
          >
            {{ 'hypervision:hypervision.synthetic.title' | translate }}</a
          >
        </li>
      </ul>
    </li>
    <li
      class="dropdown"
      [ngClass]="{
        open: openSkill
      }"
    >
      <a
        (click)="toggleSkill()"
        [ngClass]="{
          current: url$ | async | mapper: isState:HypervisionState.SKILL_SYNTHETIC:HypervisionState.SKILL_CUSTOM
        }"
        >{{ 'hypervision:menu.skill' | translate }}</a
      >
      <ul [hidden]="!openSkill">
        <li>
          <a
            [routerLink]="[HypervisionState.SKILL_SYNTHETIC]"
            routerLinkActive
            #skillSyntheticRla="routerLinkActive"
            [active]="skillSyntheticRla.isActive"
            [disabled]="skillSyntheticRla.isActive"
            [ngClass]="{ current: skillSyntheticRla.isActive }"
          >
            {{ 'hypervision:hypervision.skill-synthetic.title' | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="[HypervisionState.SKILL_CUSTOM]"
            routerLinkActive
            #skillCustomRla="routerLinkActive"
            [active]="skillCustomRla.isActive"
            [disabled]="skillCustomRla.isActive"
            [ngClass]="{ current: skillCustomRla.isActive }"
          >
            {{ 'hypervision:hypervision.skill-custom.title' | translate }}</a
          >
        </li>
      </ul>
    </li>
  </ul>
</ng-template>
<!-- Main template -->
<ng-template #main>
  <router-outlet></router-outlet>
</ng-template>
